// @ts-check

/** @file Defines the local key-value option model. */

import OptionBase from "../model-bases/option.js"
import localDatabaseModel from "../database/local-database-model.js"

/** Local key-value store backed by Velocious SQLite. */
const OptionModel = localDatabaseModel(OptionBase)

export default OptionModel
